import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "lucide-react";
import type { CaseStudyContent } from "../../data/caseStudies";
import { BODY, H2, H3 } from "../../utils/typography";
type GoDeeperProps = {
  deeper: CaseStudyContent["deeper"];
};
export function GoDeeper({
  deeper
}: GoDeeperProps) {
  const [lead, ...rest] = deeper.body;
  return <section aria-labelledby="go-deeper-heading" className="grid grid-cols-1 gap-8 rounded-3xl bg-espresso p-8 md:p-14 lg:grid-cols-12 lg:gap-12 lg:p-20" data-id="element-75" data-mp="1l6993b9beopv">
      <h2 id="go-deeper-heading" className={`${H2} text-mustard lg:col-span-5`} data-id="element-76" data-mp="1p5rwqesitdwe">
        {deeper.title}
      </h2>
      <div className="lg:col-span-7" data-id="element-77" data-mp="1yy7f3d7qc4ht">
        {lead && <p className={`${H3} text-cream`} data-id="element-78" data-mp="1yyyyzqrysds9">{lead}</p>}
        <div className={`mt-5 space-y-4 ${BODY} text-cream/75`} data-id="element-79" data-mp="11itkxufciu4t">
          {rest.map(p => <p key={p} data-id="element-80" data-mp="16gv0449ni9b0">{p}</p>)}
        </div>
        <Link to="#contact" className="mt-10 inline-flex h-12 items-center gap-3 whitespace-nowrap rounded-full bg-rust px-6 text-sm font-medium uppercase text-cream transition-colors duration-150 hover:bg-mustard hover:text-espresso" data-id="element-81" data-mp="16fjv614gyvib">
          {deeper.cta}
          <ArrowRightIcon className="h-4 w-4" data-id="element-82" data-mp="c3qr7dda1juu" />
        </Link>
      </div>
    </section>;
}